import React from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import { FiExternalLink } from "react-icons/fi";
import { BsGithub } from "react-icons/bs";
import { Link } from "react-router-dom";
import Technologies from "../../components/portfolio/Technologies";
import FullCarousel from "../../components/portfolio/FullCarousel";
import Demo from "../../components/portfolio/Demo";

import img1 from "../../assets/images/portfolio/esoma/register.png";
import img2 from "../../assets/images/portfolio/esoma/elib.png";
import img3 from "../../assets/images/portfolio/esoma/classroom1.png";
import img4 from "../../assets/images/portfolio/esoma/classroom2.png";
import img5 from "../../assets/images/portfolio/esoma/classroom3.png";
import img6 from "../../assets/images/portfolio/esoma/school-registration.png";
import img7 from "../../assets/images/portfolio/esoma/classroom4.png";
import img8 from "../../assets/images/portfolio/esoma/dashboard.png";
import img9 from "../../assets/images/portfolio/esoma/blog.png";

import demo1 from "../../assets/images/portfolio/esoma/demo1.m4v";
import demo2 from "../../assets/images/portfolio/esoma/demo2.m4v";
import demo3 from "../../assets/images/portfolio/esoma/demo3.m4v";
import demo4 from "../../assets/images/portfolio/esoma/demo4.m4v";

function Esoma() {
  const technologies = ["Laravel", "Tailwind CSS", "JQuery", "MySQL"];

  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9];

  const demos = [demo1, demo2, demo3, demo4];
  return (
    <div className="bg-slate-50 min-h-screen relative flex flex-col items-center">
      <div className="h-20 bg-cool-300 absolute top-0 w-full"></div>

      <div className="relative w-[90%] bg-white z-50 py-40 md:px-10 px-5 drop-shadow-md flex flex-col items-center mt-10 overflow-y-scroll h-[calc(100vh-4rem)]">
        <Link
          to="/portfolio"
          className="bg-cool-300 absolute top-10 left-10 text-white rounded-full w-20 h-20 flex items-center justify-center drop-shadow-md"
        >
          <IoArrowBackOutline size={50} />
        </Link>

        <div className="">
          <h1 className="text-cool-400 font-semibold text-4xl">Esoma</h1>
        </div>

        <div className="w-[80%] mt-10 drop-shadow-md">
          <h2 className="py-5  text-xl">Technologies</h2>
          <div className="flex gap-6 flex-wrap">
            <Technologies technologies={technologies} />
          </div>

          <hr className="my-10"></hr>
          <a
            href="https://github.com/eddiemg10/esoma"
            target="_blank"
            className=" text-cool-300 hover:cursor-pointer flex gap-5"
          >
            <BsGithub size={30} />
            <p className="flex items-center">
              <span>Github repository</span> <FiExternalLink className="ml-2" />{" "}
            </p>
          </a>
        </div>
        <div className="mt-20 w-full flex flex-col  items-center justify-center">
          <div className="md:w-[90%] w-full">
            <FullCarousel images={images} />
          </div>
        </div>

        <div className="font-thin text-cool-400 lg:text-xl md:text-lg text-base lg:px-20 md:px-10 px-5 mt-20">
          <p className="my-5">
            <a
              href="https://esomake.co.ke/"
              className="underline"
              target="_blank"
            >
              Esoma-KE
            </a>{" "}
            is an existing Kenyan online learning platform that offers multiple
            services including an educational blog, an e-library and a
            lightweight Learning Management System. This project aimed to revamp
            the existsing website, giving it a better look while maintaining
            full functionality.
          </p>

          <p className="my-5">
            {" "}
            Esoma was instrumental in gaining a deep understanding of core
            usability principles of interaction design such as consistency,
            flexibility, help &amp; support and error handling &amp; prevention.
            The focus was not only on improving the user interfaces' aesthetic,
            but also improving the interaction of users with the revamped system
            through understanding their main goals at various stages of
            interaction and supporting the accomplishment of these goals.
          </p>
        </div>

        <div className="mt-20 w-full">
          <h1 className="font-semibold text-4xl text-cool-400 text-center">
            System Demo
          </h1>

          <div className="w-full  mt-20">
            <Demo demos={demos} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Esoma;
